import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const ProcessingMessage = styled.div<{show: boolean, hasEverShown: boolean}>`
  width: 100%;
  margin-bottom: var(--vertical-spacing);
  opacity: ${props => props.show ? 1 : 0};
  display: ${props => props.hasEverShown ? 'block' : 'none'};
  transition: opacity var(--fade-duration) ease-in-out;
  min-width: min-content;
  flex-shrink: 1;

  @media(min-width: ${breakpoints.minWidthMedium}) {
    width: calc(50% - (var(--column-gap)/2));
  }
`;